import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Dialog Button',
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: 'Purchase additional AI credits',
        },
        {
            name: 'description',
            type: 'longText',
            defaultValue: "Credits are an add-on to your membership and never expire while you're a member.",
        },
        {
            name: 'openButton',
            type: 'object',
            defaultValue: {
                label: 'Open Dialog',
                variant: 'primary',
            },
            subFields: [
                {
                    name: 'label',
                    type: 'string',
                },
                {
                    name: 'variant',
                    type: 'string',
                    enum: ['primary', 'secondary', 'outlined-dark', 'outlined-light', 'text', 'alternate'],
                },
            ],
        },
        {
            name: 'showPrimaryCta',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'primaryCta',
            type: 'object',
            showIf: (options) => options.get('showPrimaryCta'),
            defaultValue: {
                label: 'Continue to Checkout',
            },
            subFields: [
                {
                    name: 'label',
                    type: 'string',
                },
            ],
        },
        {
            name: 'showSecondaryCta',
            type: 'boolean',
            defaultValue: false,
        },
        {
            name: 'secondaryCta',
            type: 'object',
            showIf: (options) => options.get('showSecondaryCta'),
            defaultValue: {
                label: 'Close',
            },
            subFields: [
                {
                    name: 'label',
                    type: 'string',
                },
            ],
        },
        {
            name: 'options',
            type: 'array',
            defaultValue: [
                {
                    label: '400 Credits',
                    subLabel: '40 minutes of Voiceover or 40 Remixes',
                    rightLabel: '$30',
                    badge: '100 BONUS CREDITS',
                    disabled: false,
                    selected: true,
                },
                {
                    label: '200 Credits',
                    subLabel: '20 minutes of Voiceover or 20 Remixes',
                    rightLabel: '$20',
                    badge: '',
                    disabled: false,
                    selected: false,
                },
            ],
            subFields: [
                {
                    name: 'label',
                    type: 'string',
                },
                {
                    name: 'subLabel',
                    type: 'string',
                },
                {
                    name: 'rightLabel',
                    type: 'string',
                },
                {
                    name: 'badge',
                    type: 'string',
                },
                {
                    name: 'disabled',
                    type: 'boolean',
                },
                {
                    name: 'selected',
                    type: 'boolean',
                },
            ],
        },
    ],
};
